<template>
  <div>
    <!-- <div
      class="contact_box"
      @mouseover="handleShowModal"
      @mouseleave="handleCloseModal"
    > -->
    <div class="service_box_wrap" @mouseleave="handleClosServiceeModal" @mouseover="handleShowServiceModal">
      <!-- <img class="contact_icon" :src="require('@/assets/img/contact.png')"/>
      <div v-show="contactModalVisible" class="qrcode_box"> -->
      <div class="service_box">
        <img class="service_icon" :src="require('@/assets/img/icon_customer_service.png')" />
        <div v-show="serviceModal" class="qrcode_box">

          <!-- @click="handleCloseModal" -->
          <img :src="require('@/assets/img/icon_off.png')" @click="handleClosServiceeModal" class="close_icon" />
          <p>您可以扫描二维码<br />添加企业微信联系客服</p>
          <img class="qrcode_box_img" :src="require('@/assets/img/qrcode.png')" />
        </div>
      </div>
    </div>

    <!-- 提交需求 start-->
    <div class="contact_box" @click="handleShowModal" v-if="false">
      <img class="contact_icon" :src="require('@/assets/img/contact.png')" />

    </div>
    <div  class="index_banner_left" v-show="contactModalVisible">
      <div v-if="isCase" class="index_banner_left_case_1">
        <div class="index_banner_left_case_1_title">提交需求
          <img :src="require('@/assets/img/icon_off.png')" @click="handleCloseModal" class="close_icon" />
        </div>
        <el-select placeholder="请选择创意服务" class="index_banner_left_case_1_select" v-model="service_code">
          <el-option v-for="(item,index) in service_dicts_new" :label="item.name" :value="item.code"
            :key="index"></el-option>

        </el-select>
        <!-- <el-select placeholder="请选择创意服务" class="index_banner_left_case_1_select" v-model="selectValue">
          <el-option label="职位一" value="shanghai"></el-option>
          <el-option label="职位二" value="beijing"></el-option>
        </el-select> -->
        <el-button type="primary"
          class="index_banner_left_case_1_submit_btn" @click="submitNeed">提交创意需求</el-button>
        <div class="index_banner_left_case_1_tip">
          5秒 <span>提交需求 ></span> 30分钟 <span>响应 ></span> 12小时
          <span>开始服务</span>
        </div>
      </div>
      <div v-else class="index_banner_left_case_2">
        <div class="index_banner_left_case_2_breadcrumb" @click="isCase = !isCase">
          <img :src="require('@/assets/img/icon_left.png')" alt="" />
          返回修改
          <img :src="require('@/assets/img/icon_off.png')" @click="handleCloseModal" class="close_icon" />
        </div>
        <div class="index_banner_left_case_2_text1">
          请确认您要找的创意服务：{{server_name}}
        </div>
        <div class="index_banner_left_case_2_text2">
          根据您预留的手机号将会有负责人与您联络，请保持电话畅通
        </div>
        <div class="index_banner_left_case_2_phone_input">
          <el-input placeholder="请输入您的手机号" v-model.trim="telphone" maxLength="15" @input="toNumberTel" />
        </div>
        <div style="margin-top: 12px;">
          <SlideVerify
            ref="slideVerifyEwm"
            width="100%"
            @passed="onSlidePassed"
            challengeUrl="/stapi/site/slide-challenge"
            challengeMethod="get"
            verifyUrl="/stapi/site/slide-verify"
            :verifyExtraParams="{ sys_type: 'biginhouse' }"
            :includePointsJson="false"
          />
        </div>
        <div class="index_banner_left_case_2_code_input_wrap">
          <div class="index_banner_left_case_2_code_input">
            <el-input placeholder="请输入验证码" v-model.trim="yzm" maxLength="6" @input="toNumberYzm" />
          </div>
          <button class="index_banner_left_case_2_code_btn" @click="getyzm">
            {{titlename}}
          </button>
        </div>

        <el-button type="primary" class="index_banner_left_case_1_submit_btn" @click="submitForm">确认提交需求并获取报价</el-button>
      </div>
    </div>
    <!-- 提交需求 end-->
</div>
</template>
<script>
/* eslint-disable */
  import * as commfun from "@/common/common.js"
  import axios from "axios"
  import SlideVerify from "@/components/SlideVerify.vue"
  export default {
    name: 'Footer',
    props: ['service_dicts'],
    data() {
      return {
        contactModalVisible: false,
        serviceModal: false,
        service_dicts_new:[],
        telphone:'',
        yzm:'',
        service_code:'',
        // titlename:'获取验证码',
        isCase:false,
        second: '', // 倒计时秒
        disabled: false, //倒计时停用按钮
        timer: null, //计时器
        slidePassed: false,
        slideToken: '',
      }
    },
    components: { SlideVerify },
    mounted() {
       this.service_dicts_new = this.service_dicts
    },
    computed: {
      titlename() {
        return this.disabled ? this.second + "s" : '获取验证码';
      },
      server_name() {
        return this.getServiceName(this.service_code)
      }
    },
    methods: {
      onSlidePassed (token) {
        this.slidePassed = true
        this.slideToken = token
      },
      handleShowModal() {
        this.contactModalVisible = true;
        this.isCase = true
      },
      handleCloseModal() {
        this.contactModalVisible = false;
       this.isCase= false
      },
      handleShowServiceModal() {
        this.serviceModal = true;
      },
      handleClosServiceeModal() {
        this.serviceModal = false;
      },
      showBox(type,msg) {
        this.$emit('showBox',type,msg)
      },
      submitForm: function () {
        var selfthis = this
        var url = "/stapi/site/xingyun-add"
        var service_name = this.getServiceName(this.service_code);
        var data1 = {
          service_code: this.service_code,
          service_name: service_name,
          telphone: this.telphone,
          telVerifyCode: this.yzm
        }
        console.log(data1)
        if (!data1.service_code) {
          selfthis.showBox('warning', '请选择创意服务!');
          return false;
        }
        if (!data1.telphone) {
          selfthis.showBox('warning', '请输入手机号码!');
          return false;
        }
        if (!data1.telVerifyCode) {
          selfthis.showBox('warning', '请输入验证码!');
          return false;
        }
        selfthis.sub_disabled = true
        axios.post(url, data1, { headers: { 'Content-type': 'application/x-www-form-urlencoded;charset=utf-8' } }).then(
          (response) => {
            selfthis.sub_disabled = false
            var data = response.data
            // console.log("请求成功",data)
            if (data.code == '200') {
              selfthis.visible3 = true
              selfthis.second = 0
              selfthis.telphone = ''
              selfthis.yzm = ''
              commfun.showMessage(selfthis, 'success', "信息提交成功")
            } else {
              commfun.showMessage(selfthis, 'warning', "信息提交异常：" + data.msg)
            }
          },
          (error) => {
            selfthis.sub_disabled = false
            console.log("请求失败", error.message)
            commfun.showMessage(selfthis, 'warning', "错误：网络失败")
          }
        );

      },
      toNumberTel: function (value) {
        // console.log(value)
        var selfthis = this
        commfun.numMaxLength(value, 15, function (item) {
          selfthis.telphone = item
        })
      },
      toNumberYzm: function (value) {
        // console.log(value)
        var selfthis = this
        commfun.numMaxLength(value, 6, function (item) {
          selfthis.yzm = item
        })
      },
      submitNeed: function () { //提交创意需求
        var selfthis = this
        console.log("__"+this.service_code)
        if (this.service_code) {
          this.isCase = !this.isCase
          console.log("isCase:"+this.isCase)
        } else {
          selfthis.$message({
            message: '请先选择创意服务',
            type: 'warning',
            offset: 200
          });
        }

      },
      getyzm: function () {
        let selfthis = this
        if (!this.telphone) {
          commfun.showMessage(selfthis, 'warning', '请输入手机号码!')
          return false;
        }
        if (!selfthis.slidePassed) {
          commfun.showMessage(selfthis, 'warning', '请先完成滑动验证')
          return false;
        }
        if (!selfthis.slideToken) {
          commfun.showMessage(selfthis, 'warning', '滑块凭证异常，请刷新重试')
          return false;
        }
        // 倒计时 控制start
        let s = 30 // 倒计时
        if (!selfthis.timer) {
          console.log('--start--')
          selfthis.second = s
          selfthis.disabled = true
          selfthis.timer = setInterval(() => {
            if (selfthis.second > 0 && selfthis.second <= s) {
              selfthis.second--
            } else {
              selfthis.disabled = false
              clearInterval(selfthis.timer)
              selfthis.timer = null
            }
          }, 1000)
        }
        // 倒计时 控制end
        // console.log("to api")
        //selfthis.sendSms();
        this.sendSms(this.telphone)
      },
      getServiceName: function (code) {
        var name = ''
        this.service_dicts_new.forEach(function (item, index) {
          if (code == item.code) {
            name = item.name
          }
        })
        return name;
      },
      sendSms: function (telphone) {
        var selfthis = this
        var url = "/stapi/site/sendsms2"
        const form = new URLSearchParams()
        form.append('phone', telphone || '')
        form.append('sys_type', 'biginhouse')
        form.append('type', 'index_inhouse')
        form.append('slide_token', this.slideToken || '')
        axios.post(url, form, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' }
        }).then(
          (response) => {
            var data = response.data
            console.log("请求成功", data)
            if (data.code == '200') {
              commfun.showMessage(selfthis, 'success', "成功：" + "短信发送成功")
            } else {
              selfthis.disabled = false
              clearInterval(selfthis.timer)
              selfthis.timer = null
              commfun.showMessage(selfthis, 'warning', "信息提交异常：" + data.msg)
            }

          },
          (error) => {
            console.log("请求失败", error.message)
            commfun.showMessage(selfthis, 'warning', "错误：网络失败")
          }
        );//axios end

      },

    },

  }
</script>



// WEBPACK FOOTER //
// src/components/Ewm.vue